import React from "react";
import { Link } from "react-router-dom";
import cn from "classnames";

import styles from "./styles.module.scss";

export const BUTTON_SIZE = {
    small: "small",
    normal: "normal",
};

export const BUTTON_VARIANT = {
    primary: "primary",
    secondary: "secondary",
};

export type ButtonSize = (typeof BUTTON_SIZE)[keyof typeof BUTTON_SIZE];
export type ButtonVariant = (typeof BUTTON_VARIANT)[keyof typeof BUTTON_VARIANT];

interface ButtonProps {
  to?: string;
  className?: string;
  children?: React.ReactNode;
  size?: string;
  variant?: string;
  [key: string]: any;
}

const Button: React.FC<ButtonProps> = ({
  to,
  className,
  children,
  size = BUTTON_SIZE.normal,
  variant = BUTTON_VARIANT.primary,
  ...props
}) => {

  const classNames = cn(styles.button, styles[`button--${size}`], styles[`button--${variant}`], className);

  return to ? (
    <Link to={to} className={classNames} {...props}>
      {children}
    </Link>
  ) : (
    <button className={classNames} {...props}>
      {children}
    </button>
  );
};

export default Button;
